export default {
  en: {
    snack: {
      generic_error: 'Something went wrong',
      block_success: 'Member successfully blocked',
      unblock_success: 'Member successfully unblocked',
    },
    confirm_dialog_msg: {
      block:
        "Are you sure?\n• You won't see any content from the user\n• You will not be able to chat privately anymore\n• In the group chat you will be able to see all the messages, regardless of whether user is blocked or not\n• You won't be able to send group invitations to each other anymore",
    },
    actions: {
      report: 'Report user',
      block: 'Block',
      unblock: 'Unblock',
    },
  },
};
